module.exports = __webpack_public_path__ + "img/icon_review_like.d41d8cd9.svg";